import {
  AnyAction,
  ListenerEffectAPI,
  PayloadAction,
  ThunkDispatch,
} from '@reduxjs/toolkit';

import { getFirmwares } from '../../../shared/thunks/get-firmwares/get-firmwares.thunk';
import { AppRootState } from '../../../store/models/app-state.model';
import { FiltersPayloadModel } from '../../shared/models/filters-payload.model';
import { FirmwareFilters } from '../models/firmware-filters.model';
import { FirmwareFilterListenerEffectModel } from './firmware-filter-listener-effect.model';

export const FirmwareFilterListenerEffect: FirmwareFilterListenerEffectModel = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const currentAction = action as PayloadAction<
    FiltersPayloadModel<FirmwareFilters>
  >;
  if (currentAction.payload?.property !== 'name') {
    const filters: Partial<FirmwareFilters> =
      api.getState().firmware.filters.header;
    api.dispatch(getFirmwares(filters));
  }
};
